import * as React from 'react';
import {Banner} from '@spaced-out/ui-design-system/lib/components/Banner';
import classes from './warning.module.css';


const Warning = ({
  message,
}: {
  message: string;
}): React.ReactElement<React.ComponentProps<'div'>> => {
  return (
    <div className={classes.container}>
      <Banner leftIconName="warning" semantic="warning">
        {message}
      </Banner>
    </div>
  );
};

export default Warning;
